<div>
    <!--  labelElement implemented in abstract-control-value-accessor  -->
    <label #labelElement [attr.for]="id + '_inp'" [id]="id + '_lbl'">
        <ng-content></ng-content>
        <ng-container *ngIf="isRequired">{{ REQUIRED_SIGN }}</ng-container>
        <ng-content select="[pxAfterLabelSlot]"></ng-content>
    </label>
</div>
<input
    (blur)="focusOut()"
    [(ngModel)]="value"
    [attr.aria-describedby]="hasErrorAndIsTouched ? id + '_err' : hintMessage ? id + '_hint' : null"
    [attr.aria-invalid]="ngControl?.invalid"
    [attr.aria-label]="ariaLabel"
    [attr.disabled]="disabled ? 'disabled' : undefined"
    [attr.placeholder]="placeholder"
    [attr.readonly]="readonly"
    [attr.required]="isRequired"
    [attr.title]="title"
    [class.ba-error]="hasErrorAndIsTouched"
    [class.ng-invalid]="ngControl?.invalid"
    [class.ng-valid]="ngControl?.valid"
    [id]="id + '_inp'"
    [name]="id + '_inp'"
    [type]="type"
    class="form-control"
    maxlength="10"
/>
<p *ngIf="hasErrorAndIsTouched" [id]="id + '_err'" aria-live="polite" class="form-text ba-error">
    {{ errorMessage }}
</p>
<p *ngIf="hintMessage && !hasErrorAndIsTouched" [pxHintRow]="hintType">
    <span [id]="id + '_hint'">
        {{ hintMessage }}
    </span>
</p>
